import { render, staticRenderFns } from "./AskConsentOverlay.vue?vue&type=template&id=720171c6&scoped=true"
import script from "./AskConsentOverlay.vue?vue&type=script&lang=js"
export * from "./AskConsentOverlay.vue?vue&type=script&lang=js"
import style0 from "./AskConsentOverlay.vue?vue&type=style&index=0&id=720171c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "720171c6",
  null
  
)

export default component.exports